import { BLACK_100, BLACK_300, BLACK_400, BLACK_500, BLACK_700, BLACK_900, BLUE_500, BLUE_GREY_100, BLUE_GREY_400, RED_600, GREEN_600, BLACK_600, LILAC_100, LILAC_800, LILAC_900, WHITE, YELLOW_600 } from '../../constants/colors';
export var inputDefaultProps = {
  variantStyle: 'default',
  size: 'md',
  label: '',
  hintText: '',
  containerStyle: {},
  showPrepend: false,
  prependItems: null,
  showAppend: false,
  showDivider: true,
  appendItems: null,
  state: 'none',
  useStateHintColor: true,
  isDisabled: false,
  readOnly: false,
  inputRegex: '',
  validationRegex: '',
  validationRegexFlag: undefined,
  noTextTransformHintAction: true,
  showAsTextArea: false
};
var inputNoneState = {
  labelColor: BLACK_700,
  hintColor: BLACK_700,
  characterCounterColor: BLACK_700,
  inputTextColor: BLACK_900,
  placeholderColor: BLACK_700,
  borderColor: LILAC_900,
  backgroundColor: LILAC_100,
  appendPrependIconColor: LILAC_800,
  appendPrependTextColor: BLACK_900,
  appendPrependTextAsActionColor: BLUE_500,
  appendPrependIsActionableColor: BLACK_900
};
var inputState = {
  none: inputNoneState,
  disabled: Object.assign(Object.assign({}, inputNoneState), {
    labelColor: BLACK_500,
    hintColor: BLACK_500,
    characterCounterColor: BLACK_500,
    inputTextColor: BLACK_300,
    placeholderColor: BLACK_300,
    borderColor: BLACK_500,
    backgroundColor: BLACK_100,
    appendPrependIconColor: BLACK_400,
    appendPrependTextColor: BLACK_400,
    appendPrependTextAsActionColor: BLACK_400,
    appendPrependIsActionableColor: BLACK_400
  }),
  focused: Object.assign(Object.assign({}, inputNoneState), {
    borderColor: BLUE_500
  }),
  readonly: Object.assign({}, inputNoneState),
  success: Object.assign(Object.assign({}, inputNoneState), {
    borderColor: GREEN_600,
    hintColor: GREEN_600
  }),
  error: Object.assign(Object.assign({}, inputNoneState), {
    borderColor: RED_600,
    hintColor: RED_600
  }),
  warning: Object.assign(Object.assign({}, inputNoneState), {
    borderColor: YELLOW_600,
    hintColor: YELLOW_600
  })
};
var newInputNoneState = {
  labelColor: BLACK_600,
  hintColor: BLACK_600,
  characterCounterColor: BLACK_600,
  inputTextColor: BLACK_600,
  placeholderColor: BLACK_600,
  borderColor: BLUE_GREY_400,
  backgroundColor: WHITE,
  appendPrependIconColor: BLACK_700,
  appendPrependTextColor: BLACK_900,
  appendPrependTextAsActionColor: BLUE_500,
  appendPrependIsActionableColor: BLACK_900
};
var newInputStates = {
  none: newInputNoneState,
  disabled: Object.assign(Object.assign({}, newInputNoneState), {
    labelColor: BLUE_GREY_400,
    hintColor: BLUE_GREY_400,
    characterCounterColor: BLUE_GREY_400,
    inputTextColor: BLUE_GREY_400,
    placeholderColor: BLUE_GREY_400,
    borderColor: BLUE_GREY_400,
    backgroundColor: BLUE_GREY_100,
    appendPrependIconColor: BLUE_GREY_400,
    appendPrependTextColor: BLUE_GREY_400,
    appendPrependTextAsActionColor: BLUE_GREY_400,
    appendPrependIsActionableColor: BLUE_GREY_400
  }),
  focused: Object.assign(Object.assign({}, newInputNoneState), {
    borderColor: BLUE_500
  }),
  readonly: Object.assign(Object.assign({}, newInputNoneState), {
    backgroundColor: BLUE_GREY_100
  }),
  success: Object.assign(Object.assign({}, newInputNoneState), {
    hintColor: GREEN_600,
    inputTextColor: GREEN_600,
    borderColor: GREEN_600
  }),
  error: Object.assign(Object.assign({}, newInputNoneState), {
    hintColor: RED_600,
    inputTextColor: RED_600,
    borderColor: RED_600
  }),
  warning: Object.assign(Object.assign({}, newInputNoneState), {
    hintColor: YELLOW_600,
    inputTextColor: YELLOW_600,
    borderColor: YELLOW_600
  })
};
var lightConfig = Object.assign(Object.assign({}, inputDefaultProps), {
  config: {
    states: inputState,
    newStates: newInputStates
  }
});
var whiteConfig = Object.assign(Object.assign({}, inputDefaultProps), {
  config: {
    states: Object.assign(Object.assign({}, newInputStates), {
      success: Object.assign(Object.assign({}, newInputStates.success), {
        inputTextColor: newInputStates.none.inputTextColor
      }),
      error: Object.assign(Object.assign({}, newInputStates.error), {
        inputTextColor: newInputStates.none.inputTextColor
      }),
      warning: Object.assign(Object.assign({}, newInputStates.warning), {
        inputTextColor: newInputStates.none.inputTextColor
      })
    }),
    newStates: newInputStates
  }
});
export default {
  light: lightConfig,
  dark: lightConfig,
  white: whiteConfig
};